import f, { useEffect as w, useTransition as v, useState as y, useCallback as c } from "react";
import { c as i } from "./app-a75c1d35.mjs";
import { a as p } from "./useClickOutside-726e7c36.mjs";
function M(l) {
  return w(() => {
    if (l)
      return;
    const s = [
      window.document.documentElement,
      window.document.body,
      window.document.getElementById("__next")
    ], a = s.map((o) => {
      const t = {
        overflow: o?.style.overflow || "",
        overflowX: o?.style.overflowX || "",
        overflowY: o?.style.overflowY || ""
      };
      return o && (o.style.overflow = "hidden", o.style.overflowX = "hidden", o.style.overflowY = "hidden"), t;
    });
    return () => {
      s.forEach((o, t) => {
        const e = a[t];
        o && (o.style.overflow = e.overflow, o.style.overflowX = e.overflowX, o.style.overflowY = e.overflowY);
      });
    };
  }, [l]);
}
const C = "modal", E = "modal__content", m = {
  modal: C,
  modalContent: E
};
function X({
  children: l,
  className: s,
  backdropClassName: a,
  backdropStyle: o,
  style: t,
  modalRef: e,
  id: d,
  closeModal: r
}) {
  return M(), /* @__PURE__ */ f.createElement(
    "div",
    {
      ref: e,
      id: d,
      className: i(m.modal, a),
      style: o,
      onClick: (n) => {
        n.stopPropagation(), r?.();
      },
      "data-testid": "modal"
    },
    /* @__PURE__ */ f.createElement(
      "div",
      {
        onClick: (n) => n.stopPropagation(),
        className: i(m.modalContent, s),
        style: t,
        "data-testid": "modal-content"
      },
      l
    )
  );
}
function Y(l = {}) {
  const { onClose: s, onOpen: a, defaultOpen: o = !1 } = l, [, t] = v(), [e, d] = y(o), r = c(() => {
    t(() => {
      d(!0), a?.();
    });
  }, [a]), n = c(() => {
    t(() => {
      d(!1), s?.();
    });
  }, [s]), u = c(
    () => e ? n() : r(),
    [e, r, n]
  );
  return p("Escape", n, { disabled: !e }), {
    isModalOpen: e,
    openModal: r,
    closeModal: n,
    toggleModalOpen: u
  };
}
export {
  X as M,
  M as a,
  Y as u
};
//# sourceMappingURL=useModal-4683a76a.mjs.map
